import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'productsComp',
    components:{
        headerComponent,
        FooterComponent,
        CustPopover
    },
    data(){
        return {
            session_service_details:[],
            session_product_details : [],
            search_products : '',
            state_products_list : [],
            filteredProductList : [],
            search_validation : '',
        }
    },
    computed: {
        ...mapGetters(["get_products"]),
    },
    async mounted(){
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.session_service_details = JSON.parse(this.$session.get('service_obj'));
        this.$store.state.total_services_in_cart = this.session_service_details.length;

        await this.$store.dispatch('getProducts',[this.$store.state.api,JSON.parse(this.$session.get('store_details')).store_id,1]);

        this.$store.state.products_list.forEach(product => {

            let total_product_selected  = 0; 

            if(this.$session.get('product_obj')){
                let prod_obj = JSON.parse(this.$session.get('product_obj'));
                let session_index = prod_obj.findIndex(prod => prod.product_id == product.product_id);
                if(session_index >= 0){
                    total_product_selected = prod_obj[session_index].quantity_selected;
                }else{
                    total_product_selected = 0;
                }

                if(product.product_quantity > 0){
                    product.quantity_selected = total_product_selected;  
                }else{
                    prod_obj.splice(session_index,1)
                }
            }
         
        });

        if(this.$session.get('product_obj')){
            this.session_product_details = JSON.parse(this.$session.get('product_obj'));
            this.$store.state.total_products_in_cart = this.session_product_details.length;
        }

        this.state_products_list = this.$store.state.products_list;
    },
    watch: {
        search_products:function(){
            if(this.search_products.length > 2){
                this.filteredProductList =  this.state_products_list.filter(product => {
                                                return product.product_name.toLowerCase().includes(this.search_products.toLowerCase());
                                            })
            }
            else{  
                this.filteredProductList =  [] ;
            }    

            this.filteredProductList.forEach(product => {
                var n = product.product_name.toLowerCase().search(this.search_products.toLowerCase());
                product.prod_search_value = n;
            })

            this.filteredProductList.sort(function (a, b) {
                return a.prod_search_value - b.prod_search_value;
            }); 
        },
    },
    created() {
        window.addEventListener("resize", this.onResize);
    },

    destroyed(){
        window.removeEventListener("resize", this.onResize);
        this.$store.state.products_not_available = false;
    },
    methods:{
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },

        products_filter(){
            this.search_validation='';
            if(this.search_products.length<=2 && this.search_products.length > 0){
                this.search_validation = 'Type in at least 3 alphabets to search for products.';
            }
        },

        product_continue(){
            this.$router.push('/previewbooking');
        },

        addServices(){
            this.$router.push('/home/'+ this.$store.state.store_url_name);
        },

        remove_search(){
            this.search_products = '';
        },

        quantity_change(change_type,index,prod_id,filter_index){

            let prod_obj = [];
           
            if(this.$session.get('product_obj')){
                prod_obj = JSON.parse(this.$session.get('product_obj'));
            }

            if(change_type == 'add'){
                if(filter_index == 0){
                    if(this.state_products_list[index].quantity_selected){
                        if(this.state_products_list[index].product_quantity > this.state_products_list[index].quantity_selected){
                            this.state_products_list[index].quantity_selected += 1;
                        }
                    }else if(this.state_products_list[index].product_quantity > 0){
                        this.state_products_list[index].quantity_selected = 1;
                    }
                }else{
                    if(this.filteredProductList[index].quantity_selected){
                        if(this.filteredProductList[index].product_quantity > this.filteredProductList[index].quantity_selected){
                            this.filteredProductList[index].quantity_selected += 1;
                        }
                    }else if(this.filteredProductList[index].product_quantity > 0){
                        this.filteredProductList[index].quantity_selected = 1;
                    }
                }
               
            }else{
                if(filter_index == 0){
                    this.state_products_list[index].quantity_selected -= 1;
                }else{
                    this.filteredProductList[index].quantity_selected -= 1;
                }
                
            }

            if(!prod_obj.some(prod => prod.product_id == prod_id)){
                if(filter_index == 0){
                    prod_obj.push(this.state_products_list[index]);
                }else{
                    prod_obj.push(this.filteredProductList[index]);
                }
               
            }else{
                prod_obj.forEach((prod,prod_index) => {
                    if(prod.product_id == prod_id){
                        if(filter_index == 0){
                            if(this.state_products_list[index].quantity_selected > 0){
                                prod.quantity_selected = this.state_products_list[index].quantity_selected;
                            }else{
                                prod_obj.splice(prod_index, 1);
                            }
                        }else{
                            if(this.filteredProductList[index].quantity_selected > 0){
                                prod.quantity_selected = this.filteredProductList[index].quantity_selected;
                            }else{
                                prod_obj.splice(prod_index, 1);
                            }
                        }
                        
                    }
                })
            }

            this.$store.state.total_products_in_cart = prod_obj.length;
            this.$session.set('product_obj', JSON.stringify(prod_obj));

            this.$forceUpdate();
        }
    },
    filters:{
        product_name_limit(prod_name){
            return prod_name.substr(0,20)
        },
        mobile_product_name_limit(prod_name){
            return prod_name.substr(0,18)
        },
    }
}